import { isSame, isAfter } from "@sembark-travel/datetime-utils"
import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import {
	IInstallmentsCursorResponse,
	IInstalment,
	InstalmentStatusType,
} from "./store"
import { useMemo } from "react"

export function sortInstalmentsByDueDate<
	T extends { due_at: string | Date } = { due_at: string | Date },
>(instalments: Array<T>): Array<T> {
	return instalments.concat([]).sort((a, b) => {
		return isSame(a.due_at, b.due_at, "day")
			? 0
			: isAfter(a.due_at, b.due_at)
				? 1
				: -1
	})
}

export function instalmentsXHR(xhr: XHRInstance) {
	return {
		async getInstallmentsList(
			params?: Record<string, unknown>
		): Promise<IListResponse<IInstalment>> {
			return xhr
				.get("/instalments", {
					params,
				})
				.then((resp) => resp.data)
		},
		async getInstallmentsWithCursorPagination(
			params?: Record<string, unknown>
		): Promise<IInstallmentsCursorResponse> {
			return xhr
				.get("/instalments", {
					params: {
						...params,
						pagination: "cursor",
					},
				})
				.then((resp) => resp.data)
		},
		async getpaymentsType(params?: {
			supplier_ids?: number[] | undefined
			q: string | undefined
		}): Promise<{ data: { id: string; name: string }[] }> {
			return xhr
				.get("/payments/paymentable-type-options", {
					params,
				})
				.then((resp) => resp.data)
		},

		async getBulkInstallmentPaymentInfo(
			params?: Record<string, unknown>
		): Promise<IInstallmentsCursorResponse> {
			return xhr
				.get("/bulk-payment-instalments", {
					params,
				})
				.then((resp) => resp.data)
		},
	}
}

export function getInstalmentState(
	instalment: IInstalment
): InstalmentStatusType {
	if (instalment.verified_at) return "paidVerified"
	if (instalment.paid_at) return "paidUnverified"
	if (instalment.batch_id) return "paymentPending"
	return "unpaid"
}

export function useGetInstalmentState(instalment?: IInstalment) {
	return useMemo(() => {
		if (!instalment) return "unpaid"
		return getInstalmentState(instalment)
	}, [instalment])
}
